enum MeasurementType {
    Points = 'Points',
    Dollars = 'Dollars',
}

export default MeasurementType;
